import { useMutation, useQuery } from '@tanstack/react-query'
import { AXIOS_INSTANCE } from '../api'
import { queryClient } from '../store/provider/TanStackProvider'
import { BookingSettingsAttr, BookingSettingsRes } from '../types/admissionSettings.type'

export type AppointmentBookingSettingPatch = {
  data: { type: string; id: string; attributes: BookingSettingsAttr }
}

export const useAppointmentBookingSetting = () => {
  const {
    data: bookingResource,
    isLoading,
    isFetching
  } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<BookingSettingsRes>('appointment_booking_setting')
      return data.data
    },
    queryKey: ['appointment_booking_setting']
  })

  const appointmentSetting = bookingResource?.attributes

  const { isPending: isUpdatePending, mutateAsync: updateAppointmentSetting } = useMutation({
    mutationFn: async (payload: AppointmentBookingSettingPatch) => {
      const { data } = await AXIOS_INSTANCE.patch('appointment_booking_setting', payload, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['appointment_booking_setting'] })
    }
  })

  return {
    appointmentSetting,
    bookingResource,
    isFetching,
    isLoading,
    isUpdatePending,
    updateAppointmentSetting
  }
}
